import React from 'react';

const NoAccess = () => {
    return (
        <>
            You do not appear to have access to this resources. If you believe this is an error, please contact membersupport@alas.com.
        </>
    );
}

export default NoAccess;

